<div style="background-color: white; width: 100%; max-width: 538px; height: auto; display: flex; flex-direction: column; align-items: center; padding: 12px 16px 32px 16px;">
    <div style="width: 100%; display: flex; justify-content: flex-end;">
       <img (click)="closeDialog()" onKeyDown="" src="../../../assets/icons/gray_close.svg" alt="" style="width: 16px; height: 16px; cursor: pointer;"> 
    </div>
    @if(isError){
        <img src="../../../assets/icons/warning-icon.svg" alt="" style="width: 60px; height: 60px; margin: 17px 0 16px 0;">
    }    
    <!-- <p class="info-title">Hubo un error al agendar la entrega</p> -->
    <p class="info-title text-center" *ngIf="isError">Ocurrió un error</p>   
    <p class="info-title text-center" *ngIf="message!=''" [innerHTML]="message"></p>   
    <ul>
        <li *ngFor="let error of errorList" class="info-description">{{error}}</li>
    </ul>
    <!-- <button (click)="closeDialog()" class="info-cancel-btn">{{ isError?'Regresar':'Continuar'}}</button> -->
    <button (click)="closeDialog()" class="btn btn-primary">{{ isError?'Regresar':'Continuar'}}</button>
</div>